import { Box, Flex } from '@chakra-ui/react';

import { Spinner } from '../Spinner';

import SeeMoreBtn from './SeeMoreBtn';

export const LoadMoreBtnForList = ({
  isVisibleSeeMore,
  isResults,
  isLoading,
  handlerLoadMore,
}) => {
  return (
    <Flex justifyContent={'center'}>
      {isVisibleSeeMore && isResults && (
        <>
          {!isLoading ? (
            <SeeMoreBtn
              btnText={'Load More'}
              customStyles={{ mt: '7px' }}
              onClick={handlerLoadMore}
            />
          ) : (
            <Box mt={'15px'}>
              <Spinner 
                customStyle={{ h: '30px' }}
                bgBall1="mainBlue"
                bgBall2="mainBlue"
                delayBall1={0.2}
                delayBall2={0.4}
              />
            </Box>
          )}
        </>
      )}
    </Flex>
  );
};
